/**
 * Nome del segnalatore come si mostra nell'interfaccia: iniziale maiuscola su ogni parola,
 * il resto minuscolo ("NOVELLO ILENIA" -> "Novello Ilenia"). Solo a video: il nome salvato
 * non cambia, quindi moduli di modifica, ricerche ed export usano ancora `full_name`.
 * Dopo apostrofo, trattino, & e parentesi si riparte con la maiuscola (D'Angelo, C&C);
 * dopo il punto no, così "S.R.L." diventa "S.r.l.".
 */
export function formatReferrerName(name: string | null | undefined): string {
  if (!name) return '';
  return name
    .toLocaleLowerCase('it-IT')
    .replace(/(^|[\s'’&\-(/"])(\p{L})/gu, (_, sep: string, ch: string) => sep + ch.toLocaleUpperCase('it-IT'));
}
